import RegistrarInstitutionCard from './RegistrarInstitutionCard';
export default RegistrarInstitutionCard;
